import { Box } from '@mui/material';
import { MprcChipChoice, MprcSpinnerIndicator } from 'components';
import { MprcRibbonScroll } from 'components/MprcRibbonScroll';
import { AdvCoreFilter, CoreFilterCommand, StickerAppliesTo, StickerSelectorAdvFilterResponse } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IAdvFilterCommand } from 'views/general/AdvancedFilter/interfaces';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    selectedCommands: AdvCoreFilter[];
    onChange: (filters: AdvCoreFilter[]) => void;
}

/**
 * Filtro Rápidos dos feeds
 * @param props
 */
export const TopicAdvFilters: React.FC<IProps> = (props) => {

    const { selectedCommands, onChange } = props;

    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const [loading, setLoading] = useState<boolean>(true);

    const [filterOptions, setFilterOptions] = useState<IAdvFilterCommand[]>([]);

    ////////////////////////////////////////////////////////////////////////////

    const handleSelectOption = (filter: IAdvFilterCommand) => {
        const selected = selectedCommands.some(x => x.command == filter.command && x.value == filter.fixedValue);

        if (!selected) onChange([...selectedCommands, { command: filter.command, value: filter.fixedValue }]);
        else onChange(selectedCommands.filter(p => p.command != filter.command || (p.command == filter.command && p.value != filter.fixedValue)));
    };

    /// Ao carregar o menu de rótulos
    const loadFilters = async () => {

        let stickers: StickerSelectorAdvFilterResponse[] = [];

        try {
            const response = await api.v1.selectors.stickerAdvFilter({ applyTo: StickerAppliesTo.Training });
            stickers = response.data;
        }
        finally {
        }

        var options = stickers.map(s => ({
            command: CoreFilterCommand.TrainingSticker,
            displayName: s.name,
            fixedValue: s.stickerId,
            group: 1
        } as IAdvFilterCommand));

        options.push({ command: CoreFilterCommand.TrainingWithAvailableClassrooms, displayName: t("Student.TopicView.Commands.CmdAcceptRegister"), group: 1 });
        options.push({ command: CoreFilterCommand.TrainingCurrentUserMandatory, displayName: t("Student.TopicView.Commands.CmdMandatory"), group: 1 });
        options.push({ command: CoreFilterCommand.TrainingNeverEnroll, displayName: t("Student.TopicView.Commands.CmdNeverEnroll"), group: 1 });
        options.push({ command: CoreFilterCommand.TrainingTypeCourseWeb, displayName: t("Student.Catalog.Commands.TypeCourseWeb"), group: 1 });
        options.push({ command: CoreFilterCommand.TrainingTypeLive, displayName: t("Student.Catalog.Commands.TypedLive"), group: 1 });
        options.push({ command: CoreFilterCommand.TrainingTypeExternalCourse, displayName: t("Student.Catalog.Commands.TypeExternalCourse"), group: 1 });
        options.push({ command: CoreFilterCommand.TrainingTypeLearnPath, displayName: t("Student.Catalog.Commands.TypeLearnPath"), group: 1 });
        //options.push({ command: CoreFilterCommand.TrainingTypeGame, displayName: t("Student.Catalog.Commands.TypeGame"), group: 1 });

        setFilterOptions(options);
        setLoading(false);
    };

    ////////////////////////////////////////////////////////////////////////////
    /// EFFECT
    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        loadFilters();
    }, []);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcRibbonScroll>
            {
                loading
                    ?
                    <Box sx={{ mt: 0.5, width: 100 }}>
                        <MprcSpinnerIndicator />
                    </Box>
                    :
                    filterOptions.map(item =>
                        <MprcChipChoice
                            key={item.command}
                            id={item.command}
                            label={item.displayName}
                            selectedBgColor="warning"
                            selected={selectedCommands.some(x => x.command == item.command && x.value == item.fixedValue)}
                            onClick={() => handleSelectOption(item)}
                        />
                    )
            }
        </MprcRibbonScroll>
    );
};
